import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { Country } from 'bookraw/shared/models/country.model';

@Injectable()
export class CountriesService extends ListService<Country> {

  url: string = '/api/admin/countries';
}
